<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'PAYMENT.SUBSCRIPTION_HISTORY' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="subscription-history">
    <div *ngIf="loading" class="subscription-history-loading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>

    <p *ngIf="!loading && error" class="subscription-history-empty ion-padding">
      {{ 'PAYMENT.HISTORY_LOAD_ERROR' | translate }}
    </p>

    <ng-container *ngIf="!loading && !error && history">
      <section *ngIf="hasTrialInfo()" class="subscription-history-section">
        <h2>{{ 'PAYMENT.TRIAL_DATES' | translate }}</h2>
        <ion-list lines="none">
          <ion-item *ngIf="history.trial.accountType">
            <ion-label>{{ 'PAYMENT.ACCOUNT_TYPE' | translate }}</ion-label>
            <ion-note slot="end">{{ history.trial.accountType }}</ion-note>
          </ion-item>
          <ion-item *ngIf="history.trial.subscriptionStartDate">
            <ion-label>{{ 'PAYMENT.TRIAL_START' | translate }}</ion-label>
            <ion-note slot="end">{{ formatDate(history.trial.subscriptionStartDate) }}</ion-note>
          </ion-item>
          <ion-item *ngIf="history.trial.trialEndDate">
            <ion-label>{{ 'PAYMENT.ACCOUNT_TRIAL_END' | translate }}</ion-label>
            <ion-note slot="end">{{ formatDate(history.trial.trialEndDate) }}</ion-note>
          </ion-item>
          <ion-item *ngIf="history.trial.subscriptionEndDate">
            <ion-label>{{ 'PAYMENT.CURRENT_EXPIRATION' | translate }}</ion-label>
            <ion-note slot="end">{{ formatDate(history.trial.subscriptionEndDate) }}</ion-note>
          </ion-item>
          <ion-item *ngIf="history.trial.ownerPremiumTrialStart">
            <ion-label>{{ 'PAYMENT.OWNER_TRIAL_START' | translate }}</ion-label>
            <ion-note slot="end">{{ formatDate(history.trial.ownerPremiumTrialStart) }}</ion-note>
          </ion-item>
          <ion-item *ngIf="history.trial.ownerPremiumTrialEnd">
            <ion-label>{{ 'PAYMENT.OWNER_TRIAL_END' | translate }}</ion-label>
            <ion-note slot="end">{{ formatDate(history.trial.ownerPremiumTrialEnd) }}</ion-note>
          </ion-item>
        </ion-list>
      </section>

      <section class="subscription-history-section">
        <h2>{{ 'PAYMENT.SUBSCRIPTION_RECORDS' | translate }}</h2>
        <ion-list *ngIf="history.subscriptions.length" lines="full">
          <ion-item *ngFor="let sub of history.subscriptions">
            <ion-label>
              <h3>{{ sub.status || ('GENERAL.NOT_AVAILABLE' | translate) }}</h3>
              <p *ngIf="sub.planId">{{ sub.planId }}</p>
              <p *ngIf="sub.firstBillingDate">
                {{ 'PAYMENT.FIRST_BILLING_DATE' | translate }}: {{ formatDate(sub.firstBillingDate) }}
              </p>
              <p *ngIf="sub.paidThroughDate || sub.expirationDate">
                {{ 'PAYMENT.CURRENT_EXPIRATION' | translate }}:
                {{ formatDate(sub.paidThroughDate || sub.expirationDate) }}
              </p>
              <p *ngIf="sub.updatedAt" class="subscription-history-meta">
                {{ 'PAYMENT.LAST_UPDATED' | translate }}: {{ formatDate(sub.updatedAt) }}
              </p>
            </ion-label>
          </ion-item>
        </ion-list>
        <p *ngIf="!history.subscriptions.length" class="subscription-history-empty ion-padding-horizontal">
          {{ 'PAYMENT.NO_SUBSCRIPTION_HISTORY' | translate }}
        </p>
      </section>

      <section *ngIf="history.events.length" class="subscription-history-section">
        <h2>{{ 'PAYMENT.SUBSCRIPTION_ACTIVITY' | translate }}</h2>
        <ion-list lines="full">
          <ion-item *ngFor="let event of history.events">
            <ion-label>
              <h3>{{ eventLabel(event) }}</h3>
              <p>{{ formatDate(event.date) }}</p>
              <p *ngIf="eventDetail(event)" class="subscription-history-meta">{{ eventDetail(event) }}</p>
            </ion-label>
          </ion-item>
        </ion-list>
      </section>
    </ng-container>
  </div>
</ion-content>
